export default function NotFound({ type }) {
  return (
    <div className="vp-bg">
      <div className="vp-scene">
        <div className="vp-orb vp-orb-1" />
        <div className="vp-orb vp-orb-2" />
        <div className="vp-orb vp-orb-3" />
        <div className="vp-noise" />
      </div>
      <div className="vp-center">
        <div className="vp-panel">
          <div className="vp-notfound">
            <div className="vp-notfound-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
                <line x1="9" y1="9" x2="9.01" y2="9" />
                <line x1="15" y1="9" x2="15.01" y2="9" />
              </svg>
            </div>
            <h2 className="vp-notfound-title">
              {type === 'no-username' ? 'No Profile Selected' : 'Profile Not Found'}
            </h2>
            <p className="vp-notfound-text">
              {type === 'no-username'
                ? 'Please provide a username in the URL.'
                : 'The profile you are looking for does not exist or is unavailable.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
